/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getProcessItem } from '../fn/process-item/get-process-item';
import { GetProcessItem$Params } from '../fn/process-item/get-process-item';
import { getProcessItems } from '../fn/process-item/get-process-items';
import { GetProcessItems$Params } from '../fn/process-item/get-process-items';
import { getProcessItems1 } from '../fn/process-item/get-process-items-1';
import { GetProcessItems1$Params } from '../fn/process-item/get-process-items-1';
import { PagedModelProcessItemResponse } from '../models/paged-model-process-item-response';
import { ProcessItemResponse } from '../models/process-item-response';


/**
 * Individual item-level results within a synchronization process. Each process item represents the outcome of processing a single product SKU during a sync run. Required role: EASYLOT_ADMIN or PRICE_SYNC_ADMIN.
 */
@Injectable({ providedIn: 'root' })
export class ProcessItemService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProcessItems()` */
  static readonly GetProcessItemsPath = '/process/{processId}/items';

  /**
   * List process items (paginated).
   *
   * Returns a paginated list of item-level results for a given process.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProcessItems()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItems$Response(params: GetProcessItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProcessItemResponse>> {
    const obs = getProcessItems(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List process items (paginated).
   *
   * Returns a paginated list of item-level results for a given process.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProcessItems$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItems(params: GetProcessItems$Params, context?: HttpContext): Observable<PagedModelProcessItemResponse> {
    const resp = this.getProcessItems$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProcessItemResponse>): PagedModelProcessItemResponse => r.body)
    );
  }

  /** Path part for operation `getProcessItems1()` */
  static readonly GetProcessItems1Path = '/process/{processId}/items/all';

  /**
   * Get all process items (unpaginated).
   *
   * Returns all item-level results for a given process as a list. Use `/process/{processId}/items` for the paginated variant.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProcessItems1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItems1$Response(params: GetProcessItems1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProcessItemResponse>>> {
    const obs = getProcessItems1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all process items (unpaginated).
   *
   * Returns all item-level results for a given process as a list. Use `/process/{processId}/items` for the paginated variant.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProcessItems1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItems1(params: GetProcessItems1$Params, context?: HttpContext): Observable<Array<ProcessItemResponse>> {
    const resp = this.getProcessItems1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ProcessItemResponse>>): Array<ProcessItemResponse> => r.body)
    );
  }

  /** Path part for operation `getProcessItem()` */
  static readonly GetProcessItemPath = '/process/{processId}/item/{processItemId}';

  /**
   * Get process item by ID.
   *
   * Returns the result of a single product SKU processed within a given sync process.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProcessItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItem$Response(params: GetProcessItem$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessItemResponse>> {
    const obs = getProcessItem(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get process item by ID.
   *
   * Returns the result of a single product SKU processed within a given sync process.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProcessItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProcessItem(params: GetProcessItem$Params, context?: HttpContext): Observable<ProcessItemResponse> {
    const resp = this.getProcessItem$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProcessItemResponse>): ProcessItemResponse => r.body)
    );
  }

}
